// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__KTqD-","colMaxWidth":"Table_colMaxWidth__26iQB"};